
import Vue from "vue";
import { timeToEnd } from "@/config/registrationWindow";

export default Vue.extend({
  name: "SideBar",

  data: () => ({
    logoImage: require("@/assets/images/logos/usmf-logo.png"),
    logoText: require("@/assets/images/logos/USMF1.svg"),
    items: [] as Array<MenuItemsInterface>,
    queryString: "" as string,
    timeToEnd,
  }),

  computed: {
    user() {
      return this.$store.getters["user/info"];
    },
    filteredItems() {
      return this.items.map((item) => ({
        ...item,
        items: item.items
          .filter(
            (item: any) =>
              item.children?.some(
                (el: any) =>
                  this.includesText(el.text) ||
                  el?.children?.some((child: any) =>
                    this.includesText(child.text)
                  )
              ) || this.includesText(item.text)
          )
          .map((item: any) => {
            if (item.children) {
              return {
                ...item,
                children: item.children.filter(
                  (child: any) =>
                    this.includesText(child.text) ||
                    child?.children?.some((el: any) =>
                      this.includesText(el.text)
                    )
                ),
              };
            }
            return item;
          }),
      }));
    },
    expanded: {
      get(): boolean {
        return this.$store.getters["navigation/expanded"];
      },
      set(value: boolean): void {
        this.$store.dispatch("navigation/set", value);
      },
    },
    blocked() {
      return !this.isTimeToEnd();
    },
  },

  watch: {
    "$route.fullPath"() {
      this.checkUserPermissions();
    },
    expanded(value) {
      if (value) {
        this.setSearchFocus();
      }
    },
  },

  async mounted(): Promise<void> {
    this.watchUser();
    console.log(this.user);
  },

  methods: {
    isTimeToEnd() {
      return new Date() < new Date(this.timeToEnd);
    },
    watchUser() {
      this.$watch(
        () => {
          return this.$store.getters["user/info"];
        },
        async (user) => {
          if (user) {
            const response: any = await import(`../../static/data/menu.json`);

            this.items =
              (response.default[user.role.name] as Array<MenuItemsInterface>) ||
              [];

            if (this.user.role.name === "guest") {
              this.checkUserPermissions();
            }
          }
        },
        {
          immediate: true,
        }
      );
    },
    checkUserPermissions() {
      const [{ items }]: Array<any> = this.items;

      if (this.user.has_application) {
        const deletedIndex = items.findIndex(
          (item: any) => item.to === "/application"
        );

        if (deletedIndex !== -1) {
          items.splice(deletedIndex, 1);
        }

        return;
      }

      if (this.user.has_application) {
        this.$router.push("/has-application");
      }

      if (
        this.user.role?.name === "guest" &&
        !this.user.has_application &&
        this.blocked
      ) {
        // this.$router.push("/admission-end");
        return;
      }

      const deletedIndex = items.findIndex(
        (item: any) => item.to === "/preview"
      );

      if (deletedIndex !== -1) {
        items.splice(deletedIndex, 1);
      }
    },
    includesText(text: any): boolean {
      return this.$t(text)
        .toString()
        .toLowerCase()
        .includes(this.queryString.toLowerCase());
    },
    setSearchFocus() {
      setTimeout(() => {
        (this.$refs.searchInput as Vue)?.focus();
      }, 300);
    },
    async logout(): Promise<void> {
      try {
        await this.$store.dispatch("authentication/logout");
        await this.$router.push("/auth/login");
      } catch (e) {
        await this.$store.dispatch("alert/showError", e.message);
      }
    },
    close(value: boolean): void {
      if (!value) {
        this.$store.dispatch("navigation/set", value);
      }
    },
    toMain(): void {
      this.$router.push("/");
    },
  },
});
